import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import { getInitials } from './attendanceDisplayUtils';

const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    const [y, m, d] = dateStr.split('-');
    return `${d}.${m}`;
};

function AttendanceMobileAbsenceRow({ absence }) {
    const emp = absence.employees;
    const initials = getInitials(emp?.name, emp?.surname);
    const isSingleDay = absence.absence_start === absence.absence_end || !absence.absence_end;
    const dateLabel = isSingleDay
        ? formatDate(absence.absence_start)
        : `${formatDate(absence.absence_start)}–${formatDate(absence.absence_end)}`;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1.25 }}>
            <Avatar sx={{ bgcolor: 'grey.400', color: 'white', flexShrink: 0 }}>{initials}</Avatar>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body1" sx={{ fontWeight: 600 }} noWrap>
                    {emp?.name} {emp?.surname}
                </Typography>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    {absence.type || 'urlop wypoczynkowy'} · {dateLabel}
                </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                –
            </Typography>
        </Box>
    );
}

export default AttendanceMobileAbsenceRow;
